var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 8.0829C76.1632 3.08119 86.8368 3.08119 95.5 8.0829L138.081 32.6671C146.744 37.6688 152.081 46.9124 152.081 56.9158V106.084C152.081 116.088 146.744 125.331 138.081 130.333L95.5 154.917C86.8368 159.919 76.1632 159.919 67.5 154.917L24.9189 130.333C16.2557 125.331 10.9189 116.088 10.9189 106.084V56.9158C10.9189 46.9124 16.2557 37.6688 24.9189 32.6671L67.5 8.0829Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13.3301C77.641 10.6506 83.359 10.6506 88 13.3301L135.787 40.9199C140.428 43.5994 143.287 48.5513 143.287 53.9103V109.09C143.287 114.449 140.428 119.401 135.787 122.08L88 149.67C83.359 152.349 77.641 152.349 73 149.67L25.2132 122.08C20.5721 119.401 17.7132 114.449 17.7132 109.09V53.9103C17.7132 48.5513 20.5721 43.5994 25.2132 40.9199L73 13.3301Z",
    fill: "url(#paint0_linear_155_11016)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16.7528C78.0222 14.4306 82.9778 14.4306 87 16.7528L133.323 43.4972C137.345 45.8195 139.823 50.1111 139.823 54.7556V108.244C139.823 112.889 137.345 117.181 133.323 119.503L87 146.247C82.9778 148.569 78.0222 148.569 74 146.247L27.6773 119.503C23.655 117.181 21.1773 112.889 21.1773 108.244V54.7556C21.1773 50.1111 23.655 45.8195 27.6773 43.4972L74 16.7528Z",
    fill: "url(#paint1_linear_155_11016)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_11016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5742 57.6292C74.5742 53.8599 77.6408 50.7933 81.4102 50.7933H83.776L83.0623 48.8095C82.661 47.6938 81.6096 47 80.4891 47C80.1786 47 79.8628 47.0533 79.5541 47.1657L55.6484 55.8666C54.2272 56.384 53.4958 57.9566 54.0161 59.3767L55.2793 62.8245H74.5742V57.6292Z",
    fill: "url(#paint2_linear_155_11016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4102 54.8945C79.9 54.8945 78.6758 56.1187 78.6758 57.6289V62.8242H102.602V57.6289C102.602 56.1187 101.377 54.8945 99.8672 54.8945H81.4102Z",
    fill: "url(#paint3_linear_155_11016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.848 102.268H100.277C94.6233 102.268 90.0234 97.6677 90.0234 92.0137C90.0234 86.3597 94.6233 81.7598 100.277 81.7598H109.848V72.3945C109.848 69.3743 107.399 66.9258 104.379 66.9258H51.4688C48.4485 66.9258 46 69.3743 46 72.3945V111.531C46 114.551 48.4485 117 51.4688 117H104.379C107.399 117 109.848 114.551 109.848 111.531V102.268Z",
    fill: "url(#paint4_linear_155_11016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.949 85.8613H100.277C96.8849 85.8613 94.125 88.6213 94.125 92.0137C94.125 95.4061 96.8849 98.166 100.277 98.166H113.949C115.08 98.166 116 97.246 116 96.1152V87.9121C116 86.7813 115.08 85.8613 113.949 85.8613ZM100.277 94.0645C99.1448 94.0645 98.2266 93.1463 98.2266 92.0137C98.2266 90.8811 99.1448 89.9629 100.277 89.9629C101.41 89.9629 102.328 90.8811 102.328 92.0137C102.328 93.1463 101.41 94.0645 100.277 94.0645Z",
    fill: "url(#paint5_linear_155_11016)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_155_11016",
    x1: 80.5,
    y1: 9,
    x2: 80.5,
    y2: 154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_155_11016",
    x1: 80.5,
    y1: 13,
    x2: 80.5,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_155_11016",
    x1: 68.8122,
    y1: 47,
    x2: 68.8122,
    y2: 62.8245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_155_11016",
    x1: 90.6387,
    y1: 54.8945,
    x2: 90.6387,
    y2: 62.8242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_155_11016",
    x1: 77.9238,
    y1: 66.9258,
    x2: 77.9238,
    y2: 117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_155_11016",
    x1: 105.062,
    y1: 85.8613,
    x2: 105.062,
    y2: 98.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_11016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(46 47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoAccounts);
export default __webpack_public_path__ + "static/media/icon_no_accounts.6d49ddec6cc77127f86eaa2137ec9fed.svg";
export { ForwardRef as ReactComponent };